<template>
  <van-popup v-model="openModal" @click-overlay="maskClicked">
    <div class="m-pop">
      <div class="m-pop-box">
        <div class="m-pop-cont">
          <!--<img class="m-pop-img" src="../../../../public/images/emot-info.png" alt="">-->
          <h6 class="m-pop-title">未选项目提示</h6>
          <div class="m-pop-fixation">
            <i class="icon icon-note"></i>
            <div>以下推荐项目，您本次体检选择不检查，可能存在一定的漏检风险，请确认：</div>
          </div>
          <div class="m-project-list">
            <div v-for="(item,index) in deleteProjects">
              {{index+=1}}、{{item.item}}
            </div>
          </div>

          <!--<h5 class="m-pop-text" v-html="processing(showTxt)"></h5>-->
        </div>
        <div class="m-pop-foot">
          <div class="notarize"><i class="icon" :class="{'active icon-radiochecked-copy': notarizeState ,'icon icon-danxuankuang': !notarizeState }" @click="notarizeState = !notarizeState"></i>已阅读 <span @click="lookExplain">《风险免责说明》</span>,自行承担漏检风险</div>
          <!--van-icon van-icon-checked icon-danxuankuang van-icon van-icon-check  van-icon van-icon-check   icon-radiochecked-copy-->
          <!--this.$router.push({path: '/surveyReport/information'})-->
          <!--<button class="btn" v-for="(item,index) in btnList" @click="btnClick(index)">{{item}}</button>-->
          <!--<button class="btn">完善信息</button>-->
          <div>
            <button class="btn" @click="btnClick(0)">返回修改</button>
            <button class="btn"  @click="btnClick(1)">没问题，下一步</button>
          </div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Popup } from 'vant'
import Vue from 'vue'

Vue.use(Popup)
export default {
  data () {
    return {
      notarizeState: this.recordCode
    }
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    recordCode: {
      type: Boolean,
      default: false
    },
    deleteProjects: {
      type: Array,
      default: []
    }
  },
  computed: {
    openModal: {
      get: function () {
        return this.showModal
      },
      set: function (v) {
        return !this.showModal
      }
    }
  },
  watch: {
    recordCode (newV, oldV) {
      this.notarizeState = newV
    }
  },
  methods: {
    btnClick (index) {
      this.$emit('btnClick', index, this.notarizeState)
    },
    maskClicked (e) {
      this.$emit('btnClick', 'mask')
    },
    lookExplain (e) {
      this.$emit('lookExplain', this.notarizeState)
    }
  }
//  name: 'showKnowledge'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/scss" lang="scss" scoped>
  @import "@/assets/style/variables.scss";

  .van-popup /deep/{
    top: 60%;
    width: 90%;
    background: transparent !important;
  }
  .m-pop {
    background: transparent;
    top:0;
    width: 100%;
    .m-pop-box {
      border-radius: 15px;
      padding-bottom: 20px;
      background-color: #ffffff;
      .m-project-list{
        height: 100px;
        padding-bottom: 15px;
        max-height: 200px;
        line-height: 1.5;
        overflow-y: auto;
        padding-top: 8px;
        font-size: 16px;
        text-align: left;
        padding-left: 15px;
      }
      .m-pop-fixation{
        display: flex;
        padding-bottom: 8px;
        border-bottom: 1px solid $darkEEE;
        i{
          font-size: 0px;
        }
        div{
          padding-left: 10px;
          text-align: left;
          font-size: 16px;
          width: 100%;
        }
      }
      .m-pop-cont {
        position: relative;
        width: 100%;
        /*height: 140px;*/
        padding: 20px 20px 0 20px;
        text-align: center;
        h4 {
          font-weight: bold;
          line-height: 44px;
          font-size: 18px;
          color: #333333;
        }
        p {
          line-height: 24px;
          font-size: 14px;
          color: #666666;
        }
        .m-pop-title {
          line-height: 44px;
          /*padding: 30px 0 10px;*/
          font-size: 20px;
          /*border-bottom: 1px solid #eeeeee;*/
          font-weight: bold;
          color: $assertive;
        }
      }
      p {
        width: 100%;
        height: 50px;
        line-height: 50px;
        text-align: center;
        font-size: 16px;
        border-top: 1px solid #f5f5f5;
        color: #f25930;
      }
      .m-pop-foot {
        text-align: center;
        padding: 10px 15px 15px 15px;
        justify-content: space-around;
        .notarize{
          font-size: 15px;
          padding: 15px 3px;
          text-align: left;
          line-height: 30px;
          i{
            position: relative;
            top: 3px;
            margin-right: 5px;
            font-size: 24px;
          }
          .active{
            color: $assertive;
          }
          span{
            color: #20a5fe;
          }
        }
        .btn {
          height: 30px;
          line-height: 28px;
          padding: 0 24px;
          font-size: 14px;
          border-radius: 8px;
          &:first-child {
            margin-left: 10px;
            background-color: #ffffff;
            border: 1px solid rgb(242, 89, 48);
            color: rgb(242, 89, 48);
          }
          &:last-child {
            margin-left: 20px;
            background-color: rgb(242, 89, 48);
            border: 1px solid rgb(242, 89, 48);
            color: #ffffff;
          }
        }
      }
    }
  }

</style>
